<template>
    <v-container id="heading-wrapper" class="text-center">
        <v-row v-if="page" column justify-center align-center>
            <!-- PRODUCT HEADING -->
            <v-col
                v-if="page._type === 'product'"
                cols="12"
                md="6"
                class="heading heading--product-block"
            >
                <ProductIcons
                    v-if="page._type === 'product' && page.series"
                    :page="page"
                />
                <h1 v-if="maybeTitle">{{ maybeTitle }}</h1>
                <h2 v-if="maybeSubtitle" class="subtitle-1 font-italic">
                    <span>{{ maybeSubtitle }}</span>
                </h2>
            </v-col>
            <v-col v-if="page._type === 'product'" cols="12" md="6">
                <!-- <pre>{{}}</pre> -->
                <div
                    style="width: 100%; height: 200px"
                    class="d-flex align-center justify-center"
                >
                    <EmbedSanityImage
                        :selectedImage="
                            page.sanityHeaderImage &&
                            page.sanityHeaderImage.selectedImage
                        "
                        :image-align="img.align"
                        classes="ma-0"
                        mobile-width="100"
                        tablet-width="100"
                        desktop-width="100"
                        :alt="page.sanityHeaderImage && page.sanityHeaderImage.alt[$i18n.locale]
                        ? page.sanityHeaderImage.alt
                        : { en: 'c3controls image', es: 'c3controls image' }"
                        height="148"
                        width="300"
                    />
                </div>
            </v-col>
            <!-- NON-PRODUCT HEADING -->
            <v-col v-else cols="12" :class="`heading ${defaultHeadingClass}`">
                <h1 id="page-heading" itemprop="headline">
                    <span v-if="page.title && page.title[$i18n.locale]">{{
                        page.title[$i18n.locale]
                    }}</span>
                    <span v-else
                        ><TranslatableStringComponent
                            :tstring="{ string: 'defaultPageHeading' }"
                    /></span>
                </h1>
                <div v-if="page.subtitle && page.subtitle[$i18n.locale]">
                    <h2 class="font-regular">
                        <span>{{ page.subtitle[$i18n.locale] }}</span>
                    </h2>
                </div>
                <BlockContent
                    v-if="page.intro && page.intro[$i18n.locale]"
                    :blocks="page.intro[$i18n.locale]"
                />
            </v-col>
            <!-- ALL HEADINGS -->
            <v-col
                v-if="defaultHeadingClass === 'heading--default'"
                cols="12"
                class="separator-wrapper"
            >
                <Separator
                    steez="fancy"
                    :color="calcColor(page.fontColor, colors.primary)"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import ProductIcons from '~/components/ProductIcons.vue'
import Separator from '~/components/Separator.vue'
import setCloudinaryData from '~/util/setCloudinaryData'
import colorUtilities from '~/mixins/colorUtilities'
import productUtilities from '~/mixins/productUtilities'
export default {
    name: 'Heading',
    components: {
        EmbedCloudinary2,
        ProductIcons,
        EmbedSanityImage,
        Separator,
        TranslatableStringComponent,
    },
    mixins: [colorUtilities, productUtilities],
    props: {
        page: {
            type: Object,
            default: null,
        },
        headingClass: {
            type: String,
            default: 'heading--default',
        },
        template: {
            type: String,
            default: '',
        },
    },
    computed: {
        defaultHeadingClass() {
            if (this.template === 'Product') {
                return 'heading--product-block'
            }
            if (this.template === 'Shop') {
                return 'heading--basic'
            }
            return this.headingClass
        },
        img() {
            return this.maybeThumbnail
                ? setCloudinaryData(this.maybeThumbnail, 'headerThumbnail')
                : {}
        },
    },
}
</script>
